import { OpenGlCalendarsType } from 'pages/VendorsTablePage/components/PrintChecks/types';

export const openGlCalendarsData: OpenGlCalendarsType = {
  currentStart: '2024-11-01',
  postaheadStart: '2024-12-01',
  glCutoffDate: '2024-08-27',
  glCutoffTime: '13:08:45'
};
